import React from "react";

const MainContainer = ({ children }) => {
  return (
    <main id="main-content" className="content p-3 my-3" tabIndex="-1">
      <div className="container">
        <div className="row">{children}</div>
      </div>
    </main>
  );
};

export default MainContainer;
